/* Body-map answers. Voice: recognise where the day lands; never promise an outcome.
   "Area of concern" wording is Phiten Japan's mandate - keep symptom language out. */
window.PHITEN_ZONES = {
  neck:  {tag:"Where most people start", title:"Neck & shoulders",
          copy:"Every screen you looked down at today ends up here. It is where most people start with Phiten, whether they train or not — a disc at the base of the neck before the first call, put on and forgotten.",
          products:["Metax Power Tape Discs — 70 pack","Rakuwa Necklace S-II MG","Metax Lotion"],
          href:"/products/metax-power-tape-discs", cta:"Start with the discs"},
  back:  {tag:"Long days", title:"Lower back",
          copy:"Long drives, long flights, long sits, heavy lifts — the lower back quietly pays for all of them. A strip of X30 across it stays with you through the workday, a shower and the drive home.",
          products:["Titanium Power Tape X30 — roll","Metax Lotion","Phiten Extreme Cool Gel"],
          href:"/products/titanium-power-tape-x30-roll", cta:"See the X30 roll"},
  elbow: {tag:"Repetition", title:"Elbows & wrists",
          copy:"The racquet, the climbing wall, the ten thousand keystrokes — small joints doing the same thing all day. Discs go exactly where you want them and stay out of your way.",
          products:["Metax Power Tape Discs — 70 pack","Titanium Power Tape X30 — roll"],
          href:"/products/metax-power-tape-discs", cta:"Start with the discs"},
  knee:  {tag:"Runners & lifters", title:"Knees & quads",
          copy:"The joint that takes the most repetitions — every stride, every stair, every squat. This is where the full ritual earns its place: warm before, tape through, cool after.",
          products:["Phiten Extreme Warm Gel","Titanium Power Tape X30 — roll","Phiten Extreme Cool Gel"],
          href:"/#ritual", cta:"See the ritual"},
  feet:  {tag:"On your feet", title:"Calves & feet",
          copy:"Ward rounds, shop floors, marathon blocks, the commute you stood through. Your feet are on duty longer than any other part of you. Insoles go with you all day; the cool gel is for the evening.",
          products:["Metax Insoles","Phiten Extreme Cool Gel","Metax Power Tape Discs — 70 pack"],
          href:"/products/metax-insoles", cta:"See the insoles"},
  face:  {tag:"End of the day", title:"Face & jaw",
          copy:"The clench you only notice when you finally stop. Phiten's patented roller, slowly from jaw to cheekbone — sixty quiet seconds a side that belong to you.",
          products:["Metax Titanium Massage Roller","Metax Lotion"],
          href:"/products/metax-titanium-massage-roller-for-face-patented-by-phiten-japan", cta:"See the roller"}
};

/* PHITEN INDIA — site interactions */
(function () {
  'use strict';

  /* --- header shadow on scroll --- */
  var hdr = document.querySelector('.hdr');
  var onScroll = function () {
    if (hdr) hdr.classList.toggle('scrolled', window.scrollY > 12);
    var sb = document.querySelector('.sticky-buy');
    if (sb) sb.classList.toggle('show', window.scrollY > 620);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* --- mobile drawer --- */
  var drawer = document.getElementById('drawer');
  document.querySelectorAll('[data-drawer-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!drawer) return;
      drawer.classList.add('open');
      document.body.style.overflow = 'hidden';
      var f = drawer.querySelector('a,button'); if (f) f.focus();
    });
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function (b) {
    b.addEventListener('click', close);
  });
  function close() {
    if (!drawer) return;
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* --- scroll reveal --- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
  document.querySelectorAll('.reveal').forEach(function (el, i) {
    el.style.transitionDelay = (Math.min(i % 4, 3) * 70) + 'ms';
    io.observe(el);
  });

  /* Sign-up forms are real Shopify customer forms (see the sections) - no
     client-side fake confirmations here. */

  /* --- body map --- */
  var zones = window.PHITEN_ZONES || {};
  function setZone(key) {
    var z = zones[key]; if (!z) return;
    var p = document.getElementById('bm-panel'); if (!p) return;
    p.querySelector('[data-bm-title]').textContent = z.title;
    p.querySelector('[data-bm-copy]').textContent = z.copy;
    p.querySelector('[data-bm-tag]').textContent = z.tag;
    var pr = p.querySelector('[data-bm-prod]');
    if (pr) {
      pr.innerHTML = '';
      (z.products || []).forEach(function (n) {
        var li = document.createElement('li'); li.textContent = String(n).trim(); pr.appendChild(li);
      });
    }
    var cta = p.querySelector('[data-bm-cta]');
    if (cta) {
      cta.textContent = z.cta || 'See what goes here';
      if (z.href) cta.setAttribute('href', z.href);
    }
    document.querySelectorAll('[data-zone]').forEach(function (el) {
      var isOn = el.dataset.zone === key;
      el.classList.toggle('on', isOn);
      if (el.hasAttribute('aria-pressed')) el.setAttribute('aria-pressed', isOn ? 'true' : 'false');
    });
  }
  document.querySelectorAll('[data-zone]').forEach(function (el) {
    el.addEventListener('click', function () { setZone(el.dataset.zone); });
  });
  if (Object.keys(zones).length) setZone(Object.keys(zones)[0]);

  /* --- PDP gallery --- */
  document.querySelectorAll('.pdp-thumbs button').forEach(function (b) {
    b.addEventListener('click', function () {
      var main = document.querySelector('.pdp-main img');
      if (main) main.src = b.dataset.src;
      document.querySelectorAll('.pdp-thumbs button').forEach(function (x) { x.classList.remove('on'); });
      b.classList.add('on');
    });
  });

  /* --- swatches / filters (visual toggle only) --- */
  document.querySelectorAll('[data-group]').forEach(function (b) {
    b.addEventListener('click', function () {
      document.querySelectorAll('[data-group="' + b.dataset.group + '"]').forEach(function (x) { x.classList.remove('on'); });
      b.classList.add('on');
    });
  });

  /* --- qty --- */
  document.querySelectorAll('.qty').forEach(function (q) {
    var v = q.querySelector('span'), n = 1;
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        n = Math.max(1, n + (b.dataset.step === '+' ? 1 : -1));
        v.textContent = n;
      });
    });
  });

  /* --- duplicate marquee content for seamless loop --- */
  document.querySelectorAll('[data-marquee]').forEach(function (t) {
    t.innerHTML += t.innerHTML;
  });
})();
